<template>
<div class="chapter">
<div class="inner_page">
<p class="normal-2l"><span><a id="page_v"></a>To Frank and Ruth Osborne. Much of my life and ministry is the result of their prayers. They not only prayed for me but also provided me with my most-needed answer to prayer, their daughter as my wife!—Gerald</span></p>
<p class="normal-l"><span>I write this in hopes that my children and those who read this will learn to pray effective kingdom prayers.—Bob</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?71966924